import { GameTopic } from "./game.topic.component";
import './topiclist.style.css';
import { WebsiteTopic } from "./websites.topic.component";

export function TopicList() {
    return <section className="padding20px flexHorizontal flexWrap flexGap50 flexJustifyCenter">
        <GameTopic/>
        <WebsiteTopic/>
    </section>
}